<!--
 * @Description: 页面配置
 * @Autor: WangYuan
 * @Date: 2021-09-22 17:33:51
 * @LastEditors: WangYuan
 * @LastEditTime: 2022-01-18 16:10:43
-->
<template>
  <div class="p10">
    <config-item label='背景色'>
      <config-color-picker :value="bgColor" @input="setBgColor"></config-color-picker>
    </config-item>
    <config-item label='背景图片'>
      <FaImageUpload :value="bgImage" @input="setBgImage" :maxCount="1" />
    </config-item>
  </div>
</template>

<script>
import Vue from "vue";
import { mapGetters } from "vuex";
export default {
  name: "PageConfig",
  computed: {
    ...mapGetters(["project", "curPage"]),
    siteId() {
      return (this.curPage && this.curPage.site) || null;
    },
    bgColor() {
      const root = this.project || {};
      const globalCfg = (root.config && typeof root.config === 'object') ? root.config : { backgroundColor: '#ffffff' };
      if (this.siteId) {
        if (root.siteConfigs && root.siteConfigs[this.siteId]) {
          const val = root.siteConfigs[this.siteId].backgroundColor;
          return val != null ? val : '';
        }
        // 站点模式但无站点专属配置时，不回退到全局，返回空
        return '';
      }
      // 非站点模式才回退全局
      return globalCfg.backgroundColor || '#ffffff';
    },
    bgImage() {
      const root = this.project || {};
      const globalCfg = (root.config && typeof root.config === 'object') ? root.config : { backgroundImage: '' };
      if (this.siteId) {
        if (root.siteConfigs && root.siteConfigs[this.siteId]) {
          const val = root.siteConfigs[this.siteId].backgroundImage;
          return val != null ? val : '';
        }
        return '';
      }
      return globalCfg.backgroundImage || '';
    }
  },
  methods: {
    setBgColor(value) {
      const root = this.project || {};
      if (this.siteId) {
        if (!root.siteConfigs) Vue.set(root, 'siteConfigs', {});
        if (!root.siteConfigs[this.siteId]) Vue.set(root.siteConfigs, this.siteId, {});
        Vue.set(root.siteConfigs[this.siteId], 'backgroundColor', value);
      } else {
        if (!root.config) Vue.set(root, 'config', {});
        Vue.set(root.config, 'backgroundColor', value);
      }
    },
    setBgImage(value) {
      const root = this.project || {};
      if (this.siteId) {
        if (!root.siteConfigs) Vue.set(root, 'siteConfigs', {});
        if (!root.siteConfigs[this.siteId]) Vue.set(root.siteConfigs, this.siteId, {});
        Vue.set(root.siteConfigs[this.siteId], 'backgroundImage', value);
      } else {
        if (!root.config) Vue.set(root, 'config', {});
        Vue.set(root.config, 'backgroundImage', value);
      }
    }
  }
};
</script>